export const checkIfRuleAlreadyExist = (filterRule, dimensionRule) => {
  const isExist = filterRule.some((rule) => {
    const ruleCondition = rule;
    delete ruleCondition[0]._order;
    delete dimensionRule._order;
    return (JSON.stringify(ruleCondition[0]) === JSON.stringify(dimensionRule));
  });
  return isExist;
};
